module.exports = __webpack_public_path__ + "assets/img/FL.8c9e94b6.png";